<template>
  <div role="tablist" class="product__questions">
    <question id="1" :title="$t('questions.boxType')">
      <input-bottle-box-type v-model="value.type" />
    </question>
    <question id="2" :title="$t('questions.bottleAmount')" class="mt-2">
      <input-bottle-amount v-model="value.bottlesAmount" />
    </question>
    <question id="3" :title="$t('questions.bottleSize')" class="mt-2">
      <input-bottle-size v-model="value.bottleSize" />
    </question>
    <question id="4" :title="$t('questions.color')" class="mt-2">
      <input-color v-model="value.color" />
    </question>
    <question id="5" :title="$t('questions.boxType')" class="mt-2">
      <input-box-type-punched v-model="value.boxType" />
    </question>
    <question id="6" :title="$t('questions.printType')" class="mt-2">
      <input-print-type v-model="value.printing" />
    </question>
    <question id="7" :title="$t('questions.boxAmount')" class="mt-2">
      <input-amount v-model="value.amount" />
    </question>
    <question id="8" :title="$t('questions.additionalNotes')" class="mt-2">
      <input-additional-notes v-model="value.additionalNotes" />
    </question>
  </div>
</template>
<script>
import { ProductMixin } from './Product.mixin'
import InputBottleBoxType from '../inputs/bottle/InputBottleBoxType'
import InputBottleAmount from '../inputs/bottle/InputBottleAmount'
import InputBottleSize from '../inputs/bottle/InputBottleSize'
import InputBoxTypePunched from '../inputs/InputBoxTypePunched'

export default {
  name: 'BottleBox',
  components: {
    InputBottleBoxType,
    InputBottleAmount,
    InputBottleSize,
    InputBoxTypePunched
  },
  mixins: [ProductMixin]
}
</script>
